import { Flex, Image, Typography } from "antd";

import { AntDButtonLink } from "@arbolus-technologies/antDComponents";
import { NotFoundPageLink } from "@arbolus-technologies/models/common";
import { ARBOLUS_COLORS, getBrandLogo } from "@arbolus-technologies/theme";

import { NOT_FOUND_ERROR_CODE } from "./constants";

import styles from "./NotFoundPageView.module.scss";

const { Title } = Typography;

interface NotFoundPageViewProps {
  title: string;
  links: NotFoundPageLink[];
}

export const NotFoundPageView: React.FC<NotFoundPageViewProps> = ({
  title,
  links
}) => {
  return (
    <Flex align="center" justify="center" className={styles.container}>
      <Flex vertical align="start" gap={40} className={styles.content}>
        <Image
          src={getBrandLogo()}
          alt="Arbolus logo"
          preview={false}
          height={32}
        />
        <Title
          level={1}
          style={{ color: ARBOLUS_COLORS.bColorDashboardAccentPurpleBg }}
        >
          {NOT_FOUND_ERROR_CODE}
        </Title>
        <Title
          level={1}
          style={{
            color: ARBOLUS_COLORS.bColorDashboardAccentNeutralBorderHover
          }}
        >
          {title}
        </Title>
        <Flex align="center" gap={32} wrap className={styles.links}>
          {links.map((link) => (
            <AntDButtonLink
              key={link.label}
              pathname={link.to}
              text={link.label}
              type="text"
            />
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};
